import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import _ from "lodash";
import {Col, Row} from "reactstrap";
import {getCurrentMicroTime} from "../../../../reducers/timeMeasuring/actions";
import classnames from "classnames";
import RadioIcon from "../Components/radioIcon";

class MaxDiff extends Component {

  constructor(props) {
    super(props);

    this.state = {
      tmp: 0,
    };

    this.setAnswerValue = this.setAnswerValue.bind(this);
  }

  setAnswerValue(answer, value){
    const microTime = getCurrentMicroTime(this.props.startTime);
    let {details} = this.props;

    let detail = {};
    let detailAnswer = details.find(detail => detail.answer === answer);
    let detailValue = details.find(detail => detail.value === value);

    if(detailAnswer){
      details = details.filter(detail => detail !== detailAnswer);
      detailAnswer.value = value;

      detail = detailAnswer;
    }

    if(detailValue){
      details = details.filter(detail => detail !== detailValue);
      detailValue.answer = answer;

      detail = detailValue;
    }

    if(!detailAnswer && !detailValue){
      detail = {
        microTime,
        answer,
        value
      };
    }

    details.push(detail);

    this.setState({
      tmp: this.state.tmp+1
    });

    this.props.onDetailsUpdated(details);
  }

  validate(){
    const {details, question, validationTexts} = this.props;

    let validate = {
      valid: true,
      errors: []
    };

    if (question.required && details.length < 2){
      validate.errors.push(validationTexts.required)
    }

    validate.valid = _.isEmpty(validate.errors);

    return validate;
  }

  render(){
    const {details, question} = this.props;
    const detailLeft = details.find(detail => detail.value === 1);
    const detailRight = details.find(detail => detail.value === 2);

    return (
      <React.Fragment>
        <Row className="mb-2">
          <Col className="col-6 col-md-3 col-lg-2 text-center">{question.leftText}</Col>
          <Col className="d-none d-md-block" />
          <Col className="col-6 col-md-3 col-lg-2 text-center">{question.rightText}</Col>
        </Row>

          {question.answers.map(answer => {
            const checkedLeft = detailLeft && detailLeft.answer === answer.id;
            const checkedRight = detailRight && detailRight.answer === answer.id;

            return <div key={answer.id} className="cafetery-wrap box d-flex align-middle">
              <Col className={classnames({
                'left-text col-4 col-md-3 col-lg-2 text-center py-3': true,
                'active': (detailLeft && detailLeft.answer === answer.id),
              })} onClick={() => this.setAnswerValue(answer.id, 1)}>
                <RadioIcon checked={checkedLeft} />
              </Col>
              <Col className="text-center py-3"><span dangerouslySetInnerHTML={{__html: answer.content}}/></Col>
              <Col className={classnames({
                'right-text col-4 col-md-3 col-lg-2 text-center py-3': true,
                'active': (detailRight && detailRight.answer === answer.id),
              })} onClick={() => this.setAnswerValue(answer.id, 2)}>
                <RadioIcon checked={checkedRight} />
              </Col>
            </div>;
          })}
      </React.Fragment>
    )
  }
}

MaxDiff.propTypes = {
  question: PropTypes.shape({
    required: PropTypes.bool.isRequired,
    leftText: PropTypes.string.isRequired,
    rightText: PropTypes.string.isRequired,
    answers: PropTypes.arrayOf(PropTypes.shape({
      content: PropTypes.string.isRequired,
    }).isRequired,).isRequired,
  }).isRequired,
  details: PropTypes.arrayOf(PropTypes.shape({
    answer: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
    microTime: PropTypes.number.isRequired,
  }).isRequired),
  id: PropTypes.number.isRequired,
  onDetailsUpdated: PropTypes.func.isRequired,
  validationTexts: PropTypes.shape({
    required: PropTypes.string
  }),
};

export default connect((state) => {
  return {
    startTime: state.timeMeasuring.startTime,
  }
}, null, null, {withRef: true, forwardRef: true})(MaxDiff);